// extracted by mini-css-extract-plugin
export default {"floatingButton":"FloatingSupportButton_floatingButton__kNRc3","pulse":"FloatingSupportButton_pulse__zPh-o","icon":"FloatingSupportButton_icon__wSIf5"};